// extracted by mini-css-extract-plugin
export default {"paypalIcon":"pay-later-category_paypalIcon__9a47e","clearpayIcon":"pay-later-category_clearpayIcon__dc113","klarnaIcon":"pay-later-category_klarnaIcon__30bb6"};